import {EditorEvent} from '@mc/react-mapio';

export const IFRAME_CLASSNAME = 'iframe-classname';
export const SENDER = 'mapio';

// Získání instanceId z mapioContext nebo query parametrů
function getInstanceId(): string {
    const urlParams = new URLSearchParams(globalThis.location.search);
    return urlParams.get('instanceId') || '';
}

export function sendReadyEvent(instanceId?: string) {
    const id = instanceId || getInstanceId();
    const payload = {type: 'READY', sender: SENDER, instanceId: id};
    if (globalThis.self !== globalThis.top && !globalThis.Cypress) {
        globalThis.parent.postMessage(payload, '*'); // NOSONAR: záměrně *, protože netušíme na jaké URI je parent
    }
}

export function sendEvent(event: EditorEvent, instanceId?: string) {
    const id = instanceId || getInstanceId();
    const payload = {type: 'EVENT', sender: SENDER, instanceId: id, event};
    if (globalThis.self !== globalThis.top && !globalThis.Cypress) {
        globalThis.parent.postMessage(payload, '*'); // NOSONAR: záměrně *, protože netušíme na jaké URI je parent
    }
}

export function sendEventToChild(event: EditorEvent) {
    const iframe = document.querySelector('iframe');
    if (!iframe) return;
    iframe.contentWindow.postMessage(JSON.stringify(event), '*'); // NOSONAR: záměrně *, protože netušíme na jaké URI je parent
}

/**
 * Vrátí fokus klávesnice do mapy (iframe s enginem).
 *
 * Engine registruje posluchače klávesnice na okně iframu. Pokud po akci v mapě otevřeme
 * dialog nadřazené aplikace (např. formulář atributů po zkopírování objektu), fokus zůstane
 * po jeho zavření v nadřazeném okně a klávesové zkratky mapy (2x Esc, Enter, ...) do enginu
 * vůbec nedorazí. Proto fokus po zavření dialogu vracíme zpět do mapy.
 */
export function focusMapIframe(): void {
    // Až po zavření dialogu - modal si při zavírání sám vrací fokus na element, který byl
    // aktivní při jeho otevření (mohl už mezitím zmizet z DOM), takže musíme být poslední.
    setTimeout(() => {
        const iframe = document.querySelector<HTMLIFrameElement>(`iframe.${IFRAME_CLASSNAME}`) ?? document.querySelector('iframe');
        if (!iframe) return;
        const active = document.activeElement as HTMLElement | null;
        const tag = active?.tagName;
        // Pokud uživatel mezitím píše v nadřazené aplikaci, fokus mu nebereme
        if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || active?.isContentEditable) {
            return;
        }
        iframe.focus({preventScroll: true});
        iframe.contentWindow?.focus();
    }, 0);
}
